import config from "@Config/index";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { GROWTH_BOOK_FEATURE_FLAG_NAMES } from "constants/index";

const useIsHappyFlowBookForm = () =>
  useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.BOOKFORM_HAPPY_FLOW_V2) && !config.IS_CHINA_APP;

export default useIsHappyFlowBookForm;
